<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zGtXQr/tc-custom/9781118046876.jpg?1693541374820" alt="This image is the cover for the book Power Mentoring"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Power Mentoring
      </h1>
      <p class="bookDescription body article font2">
        <p>Written to reflect the realities of todays business environment, Power Mentoring is a nuts-and-bolts guide for anyone who wants to create a connection with a protg or mentor, or to improve a current mentoring relationship. Filled with illustrative examples and candid insights from fifty of America'smost successful mentors and protgs, Power Mentoring unlocks the secrets of great mentoring relationships and shows how anyone (including those who are well established in their careers, or those who are just starting out) can become a successful mentor or protg. Based on compelling interviews from Ellen Ensher and Susan Murphys own research, this important resource explains what it takes to develop a power mentoring network consisting of a variety of mentors across a range of organizations and industries. The authors provide strategies for establishing suchpower mentoring relationships, outline the best practices, and offer insights from mentors and protgs in a variety of fields including technology, politics, and the media.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen A. Ensher, Susan Murphy
      </h2>
      
      <p class="authorDescription body article">THE AUTHORS   ELLEN A. ENSHER is an associate professor of management at Loyola Marymount University in Los Angeles, California.     SUSAN ELAINE MURPHY is an associate professor of psychology at Claremont McKenna College and the associate dean of the Henry R. Kravis Leadership Institute in Claremont, California.    The authors will donate 50% of their profits from this book to three mentoring organizations: Big Brothers Big Sisters, Covenant House, and Special Games.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wiley
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38fd1287